import { Tooltip } from '@mui/material';
import { NavLink } from 'react-router-dom';
import customTwMerge from 'utils/twMerge';

type Props = {
  to: string;
  title: string;
  Icon: React.ReactNode;
};

export default function SidebarMenuItem({ to, title, Icon }: Props) {
  return (
    <NavLink
      key={to}
      to={to}
      className={({ isActive, isPending }) =>
        customTwMerge(
          `rounded-lg px-3 py-2 text-neutral-500 ${
            isActive
              ? 'bg-primary-300 font-medium text-neutral-0 hover:bg-primary-300/90'
              : 'hover:bg-primary-100 hover:text-neutral-700'
          }`
        )
      }
    >
      <div className="flex h-6 items-center gap-3">
        {Icon}

        <Tooltip enterDelay={700} disableInteractive title={title} className="line-clamp-1">
          <span>{title}</span>
        </Tooltip>
      </div>
    </NavLink>
  );
}
